// Scene-level shop gate. The level-up queue belongs to combat; once N40 has
// entered its post-combat reunion, opening that modal would stop World.step()
// and therefore freeze the finale clock forever.
export function pumpCombatGearShop(shop, world) {
  if (!shop || !world) return false;
  if (world.over || world.finale) {
    shop.queue = 0;
    return false;
  }
  return shop.pump();
}
